export const maestroElectricModules = [
  {
    number: '01',
    image: 'https://cdn.magicpatterns.com/uploads/9ru8QEhZi9YYHJKx6xis2g/01_interruptores_y_comandos_de_iluminacion.webp',
    title: 'INTERRUPTORES Y COMANDOS DE ILUMINACIÓN',
    description: 'Interruptores simples, dobles, triples, combinadas, retornos y puntos de luz desde cajas de derivación.',
    installations: [
      'Interruptor simple + una luminaria',
      'Interruptor simple + varias luminarias',
      'Interruptor doble + dos luces independientes',
      'Interruptor triple + tres luces independientes',
      'Luz comandada desde dos puntos',
      'Luz comandada desde tres puntos',
      'Luz comandada desde cuatro puntos',
      'Dos circuitos de iluminación desde una misma caja',
      'Interruptor con indicador o piloto',
      'Punto de iluminación desde caja de derivación'
    ]
  },
  {
    number: '02',
    image: 'https://cdn.magicpatterns.com/uploads/w4xUDMxVcJh3cJBJopSRZ8/02_iluminacion_led_y_control_de_luz.webp',
    title: 'ILUMINACIÓN LED Y CONTROL DE LUZ',
    description: 'Plafones, tiras LED, reflectores, dimmers, luz de emergencia y distintas formas de controlar iluminación.',
    installations: [
      'Plafón LED',
      'Varias luminarias LED en un mismo circuito',
      'Tira LED + fuente',
      'Varias tiras LED + fuente',
      'Reflector LED exterior',
      'Dimmer + iluminación compatible',
      'Luz de emergencia',
      'Iluminación de espejo o sector de baño',
      'Iluminación LED bajo alacena',
      'Iluminación dividida por zonas'
    ]
  },
  {
    number: '03',
    image: 'https://cdn.magicpatterns.com/uploads/vGrr2ZuGr3SaeqybF1s1dA/03_tomacorrientes_y_puntos_combinados.webp',
    title: 'TOMACORRIENTES Y PUNTOS COMBINADOS',
    description: 'Tomas simples y múltiples, puntos combinados, derivaciones y organización general de circuitos de uso cotidiano.',
    installations: [
      'Tomacorriente simple',
      'Tomacorriente doble',
      'Tomacorriente triple',
      'Varios tomacorrientes en un mismo circuito',
      'Interruptor + tomacorriente',
      'Interruptor doble + tomacorriente',
      'Tomacorriente exterior',
      'Tomacorriente con conductor de protección',
      'Alimentación de tomas desde caja de derivación',
      'Circuito completo de tomas de un ambiente'
    ]
  },
  {
    number: '04',
    image: 'https://cdn.magicpatterns.com/uploads/8YmWWrWKiq6VhneAYKuQcZ/04_sensores_y_automatismos_de_iluminacion.webp',
    title: 'SENSORES Y AUTOMATISMOS DE ILUMINACIÓN',
    description: 'Sensores de movimiento, fotocélulas, temporizadores, automáticos y control de iluminación exterior.',
    installations: [
      'Sensor de movimiento + una luminaria',
      'Sensor de movimiento + varias luminarias',
      'Sensor + comando manual',
      'Fotocélula + luminaria exterior',
      'Fotocélula + varios reflectores',
      'Temporizador de iluminación',
      'Automático de escalera',
      'Sensor crepuscular para exterior',
      'Sensor de movimiento en pasillo',
      'Sistema automático de iluminación exterior'
    ]
  },
  {
    number: '05',
    image: 'https://cdn.magicpatterns.com/uploads/4F3N9BE3SPZzfeK1V5LUrx/05_tableros_y_protecciones.webp',
    title: 'TABLEROS Y PROTECCIONES',
    description: 'Organización de tableros, diferencial, protecciones de circuitos, DPS, neutro y conductor de protección.',
    installations: [
      'Tablero domiciliario básico',
      'Interruptor general + circuitos derivados',
      'Diferencial + protecciones termomagnéticas',
      'Protección contra sobretensiones',
      'Organización de neutro y conductor de protección',
      'Tablero con iluminación y tomas separados',
      'Tablero seccional',
      'Alimentación de tablero secundario',
      'Tablero para vivienda pequeña',
      'Tablero residencial completo por circuitos'
    ]
  },
  {
    number: '06',
    image: 'https://cdn.magicpatterns.com/uploads/dpeKyKHVS8Ej4HeW27YZpf/06_equipos_y_circuitos_de_uso_dedicado.webp',
    title: 'EQUIPOS Y CIRCUITOS DE USO DEDICADO',
    description: 'Aire acondicionado, termotanque, horno, anafe, lavarropas y otros equipos que requieren verificaciones específicas.',
    installations: [
      'Aire acondicionado',
      'Termotanque eléctrico',
      'Horno eléctrico',
      'Anafe eléctrico',
      'Lavarropas',
      'Lavavajillas',
      'Secarropas',
      'Calefacción eléctrica',
      'Equipo de consumo permanente',
      'Varios consumos dedicados desde tablero'
    ]
  },
  {
    number: '07',
    image: 'https://cdn.magicpatterns.com/uploads/mgqgztutdu4Nbet7NJ5X5T/07_bombas_flotantes_y_control_de_agua.webp',
    title: 'BOMBAS, FLOTANTES Y CONTROL DE AGUA',
    description: 'Bombas, cisternas, tanques, flotantes, contactores, selectores y circuitos de comando asociados.',
    installations: [
      'Bomba con comando manual',
      'Bomba + flotante de tanque',
      'Bomba + flotante de cisterna',
      'Cisterna + tanque con dos controles de nivel',
      'Bomba presurizadora',
      'Bomba comandada mediante contactor',
      'Protección funcional de bomba',
      'Comando manual/automático de bomba',
      'Indicador de estado de bomba',
      'Sistema completo cisterna → bomba → tanque'
    ]
  },
  {
    number: '08',
    image: 'https://cdn.magicpatterns.com/uploads/2XiSfan3U2Akzjty1BBbn8/08_motores_ventilacion_y_cargas_electromecanicas.webp',
    title: 'MOTORES, VENTILACIÓN Y CARGAS ELECTROMECÁNICAS',
    description: 'Motores monofásicos, extractores, ventiladores, contactores y automatizaciones básicas de uso liviano.',
    installations: [
      'Motor monofásico básico',
      'Motor con protección asociada',
      'Motor comandado mediante contactor',
      'Extractor de aire',
      'Extractor + iluminación',
      'Ventilador de techo',
      'Ventilador + iluminación',
      'Comando manual de ventilación',
      'Automatización básica de extractor',
      'Alimentación de equipo electromecánico'
    ]
  },
  {
    number: '09',
    image: 'https://cdn.magicpatterns.com/uploads/4Jjf8HcxEoCTp4BMh6iAH4/09_timbres_senalizacion_y_circuitos_auxiliares.webp',
    title: 'TIMBRES, SEÑALIZACIÓN Y CIRCUITOS AUXILIARES',
    description: 'Timbres, fuentes, relés, pilotos, zumbadores, cerraduras y circuitos auxiliares de señalización.',
    installations: [
      'Timbre + pulsador',
      'Timbre + transformador',
      'Dos pulsadores + un avisador',
      'Un pulsador + dos avisadores',
      'Zumbador o señalización sonora',
      'Piloto luminoso de estado',
      'Fuente de baja tensión',
      'Relé auxiliar en comando sencillo',
      'Cerradura eléctrica — principio general',
      'Circuito auxiliar de señalización'
    ]
  },
  {
    number: '10',
    image: 'https://cdn.magicpatterns.com/uploads/oJWEpwQFoj5CjXDK9neGGu/10_instalaciones_completas_resueltas.webp',
    title: 'INSTALACIONES COMPLETAS RESUELTAS',
    description: 'Dormitorio, living, cocina, baño, lavadero, garage, exterior, departamento, local y vivienda tipo.',
    installations: [
      'Dormitorio completo',
      'Living / comedor',
      'Cocina',
      'Baño',
      'Lavadero',
      'Garage',
      'Patio / exterior',
      'Departamento pequeño',
      'Local comercial pequeño',
      'Vivienda tipo — visión general simplificada'
    ]
  }
] as const;
